import { useState } from "react";
import { useTranslation } from "react-i18next";
import toast from 'react-hot-toast'

const Mail = () => {
  const style = {
    style:{
      background: '#1C1B1F',
      color:'#E6E1E5'
    }
  }

  const [t] = useTranslation("global");
  const [formData, setFormData] = useState({
    Name: '',
    email: '',
    message: ''
  })

  const handleFormData = (e)=>{
      const {name, value} = e.target
      setFormData(prevFormData=> ({
        ...prevFormData,
        [name]: value
      }))
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    // const {Name, email, message} = formData
    // const mail = { Name, email, message };
    try{
    //TODO: send mail nuevo hhtp server 
    //   fetch('https://web-portfolio-lean.herokuapp.com/send-email', {
    //   method: 'POST',
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(mail)
    // }).then((Response) => {
    //   console.log(Response);
    //   if(Response.status ===200){
    //     console.log('mensaje enviado')
    //     toast.success(t("succes")) 
    //   }else{
    //     console.log('mensaje no enviado muchos pedidos')
    //     toast.error(t("error"));
    //   }
    // })
    //toast que diga que el servidor esta en mantenimiento
      toast.error(t("maintenance"),style)
    }catch(e){
      toast.error(t("error"));
      console.log(e)
    }
  }

  return (
    <div className="create">
      <div className="create-card">
      <form onSubmit={handleSubmit} className="mail-form">
        <div className="section">
          <label>{t("name")}</label>
          <input
            className="mailing-input"
            type="text" 
            required 
            value={formData.Name}
            name="Name"
            onChange={handleFormData}
          />
        </div>
        <div className="section">
          <label>Email</label>
          <input 
            className="mailing-input"
            type="text" 
            required 
            name="email"
            value={formData.email}
            onChange={handleFormData}
          />
        </div>
        <div className="section">
            <label>{t("message")}</label>
            <textarea
            className="text-area"
              rows={4}
              required
              name="message"
              value={formData.message}
              onChange={handleFormData}
            />
        </div>
        <div style={{display:'flex',justifyContent:'center',paddingTop:'10px'}}>
          <button className="Btn-contact" id="btnsbnt">{t("submit")}</button>
        </div>
      </form>
      </div>
    </div>
  );
}

export default Mail;